





























import { Component, Vue } from 'vue-property-decorator';
import { Actions, Mutations } from '@/ts/store/Constants';
import FacilityData from '@/ts/FacilityData';

@Component
export default class BookFacilityConfirmationOverlay extends Vue {
    constructor() {
        super();
    }

    get facilityBookingDate(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingDate'];
    }

    get facilityBookingTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingTime'];
    }

    get facilityBookingStartTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingStartTime'];
    }

    get facilityBookingEndTime(): string {
        return this.$store.getters['SharedFacilities/getFacilityBookingEndTime'];
    }

    get facility(): FacilityData {
        return this.$store.getters['SharedFacilities/getUserSelectedFacility'];
    }

    public openSuccessOverlay() {
        this.$store.dispatch(Actions.ADD_USER_BOOKING, {
            date: this.facilityBookingDate,
            startTime: this.facilityBookingStartTime,
            endTime: this.facilityBookingEndTime,
            facilityId: this.facility.id,
        });
    }

    public openTermsAndConditions() {
        window.open(this.facility.termsAndConditions, '_system');
    }

    public cancel() {
        this.$store.commit(Mutations.SET_BOOK_FACILITY_OVERLAY_VISIBILITY, false);
    }
}
